import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useIsMobile from "../../../hook/useIsMobile";
import Skeleton from "react-loading-skeleton";
import { favoriteActions } from '../../../store/favorite-slice'
import MobileComponent from './datatable/mobile'
import DesktopComponent from './datatable/desktop'
import useFetch from "../../../hook/useFetch";
import { useLocation } from "react-router-dom";

export default function Favorites() {


    let dispatch = useDispatch()


    const [favorites, setFavorites] = useState()

    const {get}=useFetch()

    let location=useLocation()

    const fetchFavorites=()=>{
        setFavorites(null)
        dispatch(favoriteActions.resetFavorites())
        get(`/favorites`, null, null, (data) => {
            setFavorites(data)
            dispatch(favoriteActions.setFavorites(data))
        })
    }

    useEffect(() => {
       fetchFavorites()

    }, [])

    useEffect(() => {
        if (location.state && location.state.refetch) {

            fetchFavorites()
        }
    }, [location.state])

    const { isMobile } = useIsMobile()

    if (!favorites) {
        return <Skeleton count={50} />
    }

    return <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
}